import SettingField from 'components/Fields/ReduxForm/SettingField'
import {reduxForm, Field, getFormValues} from 'redux-form'
import {connect} from 'react-redux'
import styles from './LibraryForm.css'
import {
  onClickCancel,
  deleteLibrary,
  showDeleteModal,
  hideDeleteModal,
  onClickCreateNewCategory,
  onCancelCreateNewCategory,
  onConfirmCreateNewCategory
} from 'actions/ingredients/library'

import UploadImage from 'components/Fields/ReduxForm/UploadImage'
import Select, {Creatable} from 'react-select'
import 'react-select/dist/react-select.css'
import LibraryInventoryAlert from './LibraryInventoryAlert'
import LibraryInventoryAlertModal from './LibraryInventoryAlertModal'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import CreateCategoryModal from './CreateCategoryModal'
import LibraryCOGS from './LibraryCOGS'
import LibraryCOGSModal from './LibraryCOGSModal'
import {OverlayTrigger, Popover} from 'react-bootstrap'

const validate = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter a value'
  } else if (values.name.length > 100) {
    errors.name = 'Name too long'
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value'
  } else if (values.amount <= 0) {
    errors.amount = 'Please enter a value > 0'
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input Library amount less than 100%'
  } else if (values.amount > 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input Library amount less than 100.000.000.000'
  }

  if (values.in_stock === '') {
    errors.in_stock = 'Stock is required'
  } else if (values.in_stock && values.in_stock.length > 6) {
    errors.in_stock = 'Stock must be less than 6 digits'
  }

  if (!values.cogs) {
    errors.cogs = 'Avg Cost is required'
  } else if (values.cogs.length > 11) {
    errors.cogs = 'Avg Cost must be less than 11 digits'
  }

  if (!values.stock_alert) {
    errors.stock_alert = 'The stock alert is required'
  }
  return errors
}

const renderSelectFieldWithoutCreate = ({input: {value, onChange}, meta: {dispatch}, placeholder, options, units}) => {
  const onChangeSelect = (newval) => {
    onChange(newval.value)
  }
  return (<Select
    value={value}
    className='selectCategories'
    placeholder={placeholder}
    onChange={onChangeSelect}
    options={options}
    clearable={false}
  />)
}

class RenderSelectField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectInstance: 1
    }
  }

  onChangeSelect = (newval) => {
    let isNewCategory = true
    const {input: {value, onChange}, meta: {dispatch}, options, categories} = this.props
    options.forEach((cat) => {
      if (cat.value === newval.value && typeof newval.value === 'number') {
        isNewCategory = false
      }
    })
    if (isNewCategory) {
      dispatch(onClickCreateNewCategory(newval.value, categories, value))
      onChange(newval.value)
    } else {
      onChange(newval.value)
    }
  }

  render () {
    const {input: {value}, placeholder, options} = this.props
    const selectProps = {
      addLabelText: '{label} (create new)',
      value,
      className: 'selectCategories',
      placeholder,
      onChange: this.onChangeSelect,
      options,
      clearable: false,
      backspaceRemoves: false,
      promptTextCreator: (label) => (`${label} (create new)`),
      onClose: () => { this.setState({selectInstance: 1 - this.state.selectInstance}) }
    }
    // TODO HACK buat nyamain behaviour kode lama:
    // harus dalam html tag yang beda
    // harus dua komponen yang beda
    if (this.state.selectInstance === 1) {
      return <div>
        <Creatable
          {...selectProps}
        />
      </div>
    } else {
      return <span>
        <Creatable
          {...selectProps}
        />
      </span>
    }
  }

}

const tooltipDeleteBtn = (
  <Popover id='popover-trigger-hover-focus'>
    This Ingredient can not be deleted because it has been associated with a recipe.
    Please disconnect the Ingredient from the Recipe and try again.
  </Popover>)

class LibraryForm extends React.Component {
  render () {
    let {
      libraryDetail,
      handleSubmit,
      categories,
      libraryForm,
      showDeleteModal,
      units,
      showInputCOGS,
      showInputInventory,
      isSubmittingForm,
      outlets
    } = this.props
    const uploadImagePlaceholder = (libraryForm && libraryForm.name) ? libraryForm.name.substring(0, 2) : ''

    return (
      <form onSubmit={handleSubmit} className='full-height'>
        <div className={`${styles['library-fieldset']} ingredient-library-fieldset`}>
          <div className='row'>
            <Field component='input' type='hidden' name='id' />
            <Field
              name='image.url'
              component={UploadImage}
              placeholder={uploadImagePlaceholder}
              className={styles['upload-image']}
              backgroundColor={libraryDetail ? libraryDetail.background_color : null}
              />
            <div className={`${styles['side-image-wrapper']}`}>
              <div className='row'>
                <div className='form-group'>
                  <Field
                    component={SettingField}
                    className='form-control'
                    name='name'
                    maxLength='40'
                    placeholder='Ingredient Name'
                    type='text'
                    />
                </div>
              </div>
              <div className='row'>
                <div className='form-group'>
                  <Field
                    component={RenderSelectField}
                    className='selectCategories'
                    name='ingredient_category_id'
                    options={this._formatObj(categories)}
                    categories={categories}
                    onChange={this._onChangeCategories}
                    placeholder='Uncategorized'
                    />
                </div>
              </div>
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  UNIT
                </label>
                <p>
                  <span className='form-group text-left label-instock'>
                    Unit in stock (e.g Litre, Kg, Pieces, etc)
                  </span>
                </p>
                <Field
                  component={renderSelectFieldWithoutCreate}
                  className='selectCategories'
                  name='unit_id'
                  options={this._formatObj(units)}
                  units={units}
                  onChange={this._onChangeUnits}
                  placeholder='Unit Name'
                />
              </div>
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Inventory
                </label>
                <LibraryInventoryAlert showInputInventory={showInputInventory} />
              </div>
            </div>
          </div>
          <div className={`row ${styles['margin-top-30']}`}>
            <div className='col-lg-12'>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>
                  Cost
                </label>
                <LibraryCOGS showInputCOGS={showInputCOGS} isInventoryTracked={showInputInventory} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {libraryDetail && libraryDetail.id && <span className='pull-left'>
            {libraryForm && !libraryForm.is_recipe
              ? <button className='btn btn-danger no-outline' onClick={this._onClickDelete} disabled={isSubmittingForm}>
                <i className='fa fa-trash' />
              </button>
              : <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={tooltipDeleteBtn}>
                <button className={`btn ${styles['btn-delete-disabled']}`} onClick={(e) => e.preventDefault()}>
                  <i className='fa fa-trash' />
                </button>
              </OverlayTrigger>
            }
          </span>}
          <span className='pull-right'>
            <button className='btn btn-default no-outline' type='button' style={{'margin-right': '10px'}} onClick={this._onClickCancel} disabled={isSubmittingForm}>
             Cancel
            </button>
            {libraryForm && !libraryForm.id && outlets && outlets.length > 1 && <button className='btn btn-primary no-outline' type='button' style={{'margin-right': '10px'}} onClick={handleSubmit(this._onSubmitCreateAllOutlet)} disabled={isSubmittingForm}>
              Save to All Outlets
            </button>}
            <button className='btn btn-primary no-outline' type='submit' onClick={handleSubmit(this._onSubmitSave)} disabled={isSubmittingForm}>
              Save
            </button>
          </span>
        </div>
        <LibraryInventoryAlertModal />
        <LibraryCOGSModal />
        {libraryDetail && libraryDetail.id && <LibraryDeleteModal
          name={libraryDetail.name}
          onHide={this._onHideDeleteModal}
          showDeleteModal={showDeleteModal}
          title='Library'
          onDelete={this._confirmDelete}
        />}
        <CreateCategoryModal
          dispatch={this.props.dispatch}
          newCategory={this.props.newCategory}
          show={this.props.showNewCategoryModal}
          onCancel={this._onCancelCreateCategoryModal}
          onConfirm={this._onConfirmCreateCategoryModal}
        />
      </form>
    )
  }

  _onCancelCreateCategoryModal = () => {
    const {dispatch, previousCategories, previousCategoryId} = this.props
    dispatch(onCancelCreateNewCategory(previousCategories, previousCategoryId))
  }

  _onConfirmCreateCategoryModal = () => {
    const {dispatch, newCategory} = this.props
    dispatch(onConfirmCreateNewCategory(newCategory))
  }

  _onHideDeleteModal = () => {
    const {dispatch} = this.props
    dispatch(hideDeleteModal())
  }

  _confirmDelete = () => {
    const {dispatch, libraryDetail, libraries, summary} = this.props
    dispatch(deleteLibrary(libraryDetail, libraries, summary))
  }

  _formatObj = (values) => {
    let results = []
    values.map(function (value) {
      if (value.id > 0) {
        results.push({value: value.id, label: value.name})
      }
    })
    return results
  }

  _onClickDelete = (e) => {
    const {dispatch} = this.props
    dispatch(showDeleteModal())
    e.preventDefault()
    e.stopPropagation()
  }

  _onClickCancel = (e) => {
    this.props.dispatch(onClickCancel())
    e.preventDefault()
    e.stopPropagation()
  }
  _onChangeCategories = (val, newVal) => {

  }

  _onChangeUnits = (val, newVal) => {

  }

  _onSubmitCreateAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'save_to_all_outlet'})
  }

  _onSubmitSave = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }

  _onChangeSwitch = () => {
    this.props.onChangeSwitch()
  }

  _findUncategorized = (categories) => {
    let idUncategory
    categories.map(function (category, index) {
      if (category.name === 'Uncategorized') {
        idUncategory = category.id
      }
    })
    return idUncategory
  }
}

LibraryForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
}

function mapStateToProps (state) {
  let {library} = state.ingredients
  return {
    outlets: library.outlets,
    libraryDetail: library.libraryDetail,
    units: library.units,
    libraryForm: getFormValues('library')(state),
    categories: library.categories,
    showDeleteModal: library.showDeleteModal,
    libraries: library.libraries,
    showNewCategoryModal: library.showNewCategoryModal,
    newCategory: library.newCategory,
    previousCategories: library.previousCategories,
    previousCategoryId: library.previousCategoryId,
    showInputCOGS: library.showInputCOGS,
    showInputInventory: library.showInputInventory,
    isSubmittingForm: library.isSubmittingForm,
    summary: library.summary
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'library',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
  // https://mokapos.atlassian.net/browse/FD-1669
  // Form isi -> 2 field name
  // form kosong -> 1 field name
  // di redux-form ni kalo kayak gitu kejadiannya
  // bakal diunregister field
  // yang bakal ngerusak hasil validasi
  destroyOnUnmount: false
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(LibraryForm))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/LibraryDetail/LibraryForm/LibraryForm.js